import { createRoot } from "react-dom/client";
import { App } from "./app/App";

function start() {
  console.log("%c🚀 ASSISTENTE CARREGADO", "color: #00ff00; font-size: 20px; font-weight: bold; background: black; padding: 10px;");
  const root = createRoot(document.getElementById("root")!);
  root.render(<App />);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}

